import http from '@/plugins/http'
import { Toast } from 'mint-ui'
import { PREFIX_KS_SORDER } from '@/service'
const api = {
  queryWorkerInfo: PREFIX_KS_SORDER + 'queryWorkerInfo.do' // 获取育儿顾问名字
}

export default {
  namespaced: true,
  state: {
    depList: [
      {
        msg: '请先选择服务城市',
        value: null,
        placeholder: '请选择城市',
        label: '服务城市',
        id: 'cs'
      },
      {
        msg: '请先选月嫂等级',
        value: null,
        placeholder: '请选择月嫂等级',
        label: '月嫂等级',
        id: 'dj'
      },
      {
        msg: '请先选择月嫂',
        value: null,
        placeholder: '请选择月嫂',
        label: '月嫂',
        id: 'ys'
      },
      { value: null, placeholder: '请选择预产期', label: '预产期', id: 'ycq' }
    ]
  },
  mutations: {
    setSelected(state, payload) {
      const { id, value } = payload
      if (state.depList) {
        let i = 0
        state.depList.forEach((item, index) => {
          if (id && item.id === id) {
            i = index
          }
        })
        state.depList = state.depList.map((item, index) => {
          if (item.id === id) {
            item.value = value
          }
          if (index > i) {
            item.value = null
          }
          return item
        })
      }
    }
  },
  actions: {
    verificationDepList({ state }, id) {
      let isValid = true
      const depList = state.depList
      if (id) {
        depList.reduce((accumulator, currentValue) => {
          if (id === currentValue.id && accumulator && !accumulator.value) {
            isValid = false
            Toast(accumulator.msg)
          }
          return currentValue
        }, null)
      } else {
        depList.every(item => {
          if (!item.value) {
            isValid = false
            Toast(item.placeholder)
            return false
          } else {
            return true
          }
        })
      }
      return isValid
    },
    async queryWorkerInfo(context, payload) {
      return http.get(api.queryWorkerInfo, { workerCode: payload })
    }
  },
  getters: {}
}
